import { z } from 'zod';

export const subscriptionLevel = z.enum([
  'basic',
  'premium',
  'graveyard',
  'non-client',
]);

export type TSubscriptionLevel = z.infer<typeof subscriptionLevel>;
